import { DocumentEvents } from "./../../helpers/document-events";
import { SortDictionaryDefinition } from "./../../helpers/sorter-definition-dictionary";
import { ListTabState } from "./list-tab-state";
import { GenericTabModel } from "./generic-tab";
import { IDocumentModel } from "./../../interfaces/document-model";
import { prop } from "../../../decorators/property";
import { ITabDefinition } from "../../interfaces/tab-definition";
import { TabViewDictionary } from "./../../helpers/tab-view-dictionary";
import { SortDictionary, SortableCollection } from "../../collections/sortable-collection";
import { Collection } from "backbone-associations";
import {BaseRelationModel} from "../base-relation";

export class ListTabModel extends GenericTabModel {

    /** Keep track of this so if docModel is refreshed we can pull correct data out again */
    @prop() public CollectionName: string;
    @prop() public RelationCollection: SortableCollection<BaseRelationModel>;
    @prop() public Sorters: SortDictionaryDefinition[];
    @prop() public State: ListTabState = new ListTabState();

    public constructor(properties: ITabDefinition, data: IDocumentModel) {
        super(properties, data);
        this.setDocumentData(data);
        if (!this.CollectionName) {
            // tslint:disable-next-line
            console.error("You've created a ListTabModel, but no CollectionName is Specified! Is it missing from the Tab Definition in raven?");
        }
    }

    public setDocumentData(data: IDocumentModel) {
        this.Data = data;
        if (this.Data && this.Data.get(this.CollectionName)) {
            const coll = this.Data.get(this.CollectionName);
            const toAdd = coll.models === undefined ? coll : coll.models; // Its meant to always be a collection, but sometimes it can come through as an array. If its a collection models will be defined so we use .models, otherwise we just use the coll variable which is an array
            if (!this.RelationCollection) {
                this.RelationCollection = new SortableCollection<BaseRelationModel>(this.Sorters, toAdd);
            } else {
                this.RelationCollection.reset(toAdd); // don't want to change the reference to the collection incase it breaks a listener.
                this.RelationCollection.updateComparatorFromSortPriorities();
                this.RelationCollection.setHeadings();
                this.RelationCollection.trigger("redraw");
            }
        }
    }

    public get EmptyCollectionText(): string {
        const isOrAre = this.Title.substring(this.Title.length - 1) === "s" ? "are" : "is";
        const docName = this.Data.RenderType.toLowerCase() === "case" ? "judgment" : "document";
        const html = `<div class="treatment-cell no-data"><p>There ${isOrAre} currently no ${this.Title} listed for this ${docName}.</p></div>`;
        return html;
    }

    public get Enabled() {
        if (this.RelationCollection) {
            return this.RelationCollection.size() > 0;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/list-tab.ts